import React from 'react';
import { getLocationsForBeacon } from '_utils/beacon-matching';

const BeaconLocation = ({ beacon, locations }) => {
    const matched = getLocationsForBeacon(
        locations,
        beacon?.major,
        beacon?.minor
    );
    if (matched.length === 0) return <span>—</span>;
    return <span>{matched.join(', ')}</span>;
};

export default BeaconLocation;
